import { PersonBase } from './PersonBase';
import { Stance } from './Stance';

export class Pro extends PersonBase {

	public stanceId: number;
	public stance: Stance;
	public yearTurnedPro?: number;

	constructor(init?: Partial<Pro>) {
		super();
		Object.assign(this, init);
	}

}
